// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "b289574e9dc34206","191": "f330c2afc6be5002","396": "22281190ef97a7d4","460": "5f8f2c0c6c3f4da3","498": "1bc43a0fe4829354","917": "d9c8b0ccac7e58ee","985": "77258f39429d6256",}[chunkId] + ".chunk.js"
}